import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertTitle, Box } from '@mui/material';
var ErrorMessage = function (_a) {
    var error = _a.error, _b = _a.title, title = _b === void 0 ? 'Error' : _b;
    var errorMessage = (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.toString()) || 'An unexpected error occurred';
    return (_jsx(Box, { sx: { p: 2 }, children: _jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: title }), errorMessage] }) }));
};
export default ErrorMessage;
